import PropTypes from "prop-types";
import {
  FlexContainers,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../components";
import { strCode } from "../../../consts";
import { t } from "../../../services";
import { dispatch } from "../../../state/store";
import { setFWUVersionToDelete } from "../../../state/ducks";
import { FirmwareDeleteModalContainer } from "./styled";

const FirmwareDeleteModal = ({ firmware, loading, onDeleteFWUVersion, active }) => {
  return (
    firmware && (
      <Modal
        active={active}
        closable={false}
        title={t(strCode.REMOVE_FIRMWARE_QUESTION)}
        Container={FirmwareDeleteModalContainer}>
        <WrapperContainer>
          <Paragraph2
            dangerouslySetInnerHTML={{
              __html: t(strCode.REMOVE_FIRMWARE_INFO, {
                fwuName: firmware.fwuName
              })
            }}
          />
        </WrapperContainer>
        <WrapperContainer Container={FlexContainers.FlexRowEnd} gap={8} mt={32}>
          <SmallButton
            onClick={() => dispatch(setFWUVersionToDelete(null))}
            disabled={loading}
            secondary>
            {t(strCode.CANCEL_BTN)}
          </SmallButton>

          <WrapperContainer minWidth={144}>
            <SmallButton
              onClick={() => onDeleteFWUVersion(firmware.fwuName)}
              disabled={loading}
              loading={loading}
              fullWidth
              backgroundRed>
              {t(strCode.REMOVE_BTN)}
            </SmallButton>
          </WrapperContainer>
        </WrapperContainer>
      </Modal>
    )
  );
};

FirmwareDeleteModal.propTypes = {
  loading: PropTypes.bool.isRequired,
  firmware: PropTypes.shape({
    fwuVersion: PropTypes.object,
    fwuName: PropTypes.string,
    deviceType: PropTypes.string,
    model: PropTypes.string,
    binFile: PropTypes.object,
    signatureFile: PropTypes.object,
    isNew: PropTypes.bool
  }).isRequired,
  active: PropTypes.bool.isRequired,
  onDeleteFWUVersion: PropTypes.func.isRequired
};

export default FirmwareDeleteModal;
